import { Country, PolicyType } from '@40seas/entities/common';
import { ProcessType } from '../process/process.type';
import { PolicyResult } from './policy.result';
import { Buyer } from '@40seas/entities/buyers';

export const PoliciesConfigProvider = {
    MaximumAutoApproveCreditlineAmount: 50_000,
    DefaultCreditlineAmount: 10_000,
    LowLimitPolicy: {
        conditions: [
            { score: 650, revenue: 60000, credit: 5000 },
            { score: 680, revenue: 120000, credit: 10000 },
            { score: 700, revenue: 240000, credit: 20000 },
            { score: 750, revenue: 360000, credit: 30000 },
            { score: 800, revenue: 600000, credit: 50000 },
        ],
    },
    CreditScorePGPolicy: {
        conditions: [
            { score: 680, credit: 5000 },
            { score: 700, credit: 10000 },
            { score: 750, credit: 20000 },
            { score: 800, credit: 30000 },
        ],
    },
    CreditScoreAnnualRevenuePolicy: {
        conditions: [
            { score: 700, revenue: 240000, credit: 5000 },
            { score: 750, revenue: 360000, credit: 10000 },
            { score: 800, revenue: 600000, credit: 20000 },
        ],
    },
    CreditScoreIdVerificationPolicy: {
        conditions: [
            { score: 750, credit: 5000 },
            { score: 800, credit: 10000 },
        ],
    },
    BaseProcesses: [
        ProcessType.InsuranceCover,
        ProcessType.BusinessStartDate,
        ProcessType.BusinessVerification,
        ProcessType.IdentityVerification,
    ],
    PoliciesSortFunction: (a: PolicyResult, b: PolicyResult) => {
        const policiesOrder = {
            [PolicyType.LowLimit]: 0,
            [PolicyType.CreditScoreAnnualRevenue]: 1,
            [PolicyType.CreditScoreIdVerification]: 2,
            [PolicyType.CreditScorePG]: 3,
            [PolicyType.BondRating]: 4,
            [PolicyType.FinancialActivities]: 5,
            [PolicyType.PreApproved]: 6,
        };

        return policiesOrder[a.policyType] - policiesOrder[b.policyType];
    },
    BuyerPolicies(buyer?: Buyer): PolicyType[] {
        if (!buyer?.address?.country) {
            return [];
        }

        switch (buyer.address.country) {
            case Country.UNITED_STATES:
                return [
                    PolicyType.LowLimit,
                    PolicyType.CreditScoreAnnualRevenue,
                    PolicyType.CreditScoreIdVerification,
                    PolicyType.CreditScorePG,
                    PolicyType.FinancialActivities,
                    PolicyType.PreApproved,
                ];
            // case Country.CANADA:
            //     return [BankConnectivityProvider.Plaid];
            case Country.AUSTRIA:
            case Country.BELGIUM:
            case Country.BULGARIA:
            case Country.CROATIA:
            case Country.CYPRUS:
            case Country.CZECH_REPUBLIC:
            case Country.DENMARK:
            case Country.ESTONIA:
            case Country.FINLAND:
            case Country.FRANCE:
            case Country.GERMANY:
            case Country.HUNGARY:
            case Country.ICELAND:
            case Country.IRELAND:
            case Country.ITALY:
            case Country.LATVIA:
            case Country.LIECHTENSTEIN:
            case Country.LITHUANIA:
            case Country.LUXEMBOURG:
            case Country.MALTA:
            case Country.MONACO:
            case Country.NETHERLANDS:
            case Country.NORWAY:
            case Country.POLAND:
            case Country.PORTUGAL:
            case Country.ROMANIA:
            case Country.SERBIA:
            case Country.SLOVAKIA:
            case Country.SLOVENIA:
            case Country.SPAIN:
            case Country.SWEDEN:
            case Country.SWITZERLAND:
            case Country.UNITED_KINGDOM:
                return [PolicyType.BondRating, PolicyType.FinancialActivities];
            default:
                return [PolicyType.FinancialActivities];
        }
    },
    // We will change this config structure in the future + add it to mongoDB
    ProcessesCriteria: {
        version: 1,
        processes: {
            [ProcessType.MinimalAnnualBankRevenue]: { minimalAnnualBankRevenue: 120000 },
            [ProcessType.AccountBalance]: { balance: 0 },
            [ProcessType.AvailableBankActivity]: { monthsOfBankData: 6 },
            [ProcessType.BankRevenueToRequestedCreditRatio]: { ratio: 2 },
            [ProcessType.DebtRepaymentToMonthlyBankRevenueRatio]: { ratio: 25 },
            [ProcessType.DebtAmount]: { ratio: 50 },
            [ProcessType.NetProfit]: { netProfit: 0 },
            [ProcessType.TransactionsPerMonth]: { transactionsPerMonth: 10 },
            [ProcessType.Reliability]: { reliability: 0.8 },
            [ProcessType.BusinessStartDate]: { minBusinessAge: 12 }, // in months
        },
    },
};
